<template>
  <div class="modal fade" id="html-modal" role="dialog" data-backdrop="static" data-keyboard="false" @click.stop>
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <span v-html="data.paymentMethodRegistExp"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" @click="close()">閉じる</button>
          <button type="button" class="btn btn-warning" @click="checkout()">登録する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data () {
      return this.$store.getters.getVerifyPaymentData
    }
  },
  methods: {
    close () {
      if (this.data.paymentRedirectPath && this.data.paymentRedirectPath !== this.$route.path) {
        this.$router.push(this.data.paymentRedirectPath)
      }
      $('#html-modal').modal('hide')
      $('.modal-backdrop').remove()
      this.$store.commit('toggleVerifyPaymentModal')
    },
    checkout () {
      $('#html-modal').modal('show')
      location.href = this.data.verifyPaymentCheckoutUrl
      this.$store.commit('toggleVerifyPaymentModal')
    }
  },
  mounted () {
    $('#html-modal').modal('show')
  },
  beforeDestroy () {
    $('#html-modal').modal('hide')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.modal-footer {
  border-top: unset;
  background-color: #fff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/VerifyPaymentModal.vue